import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GTM_EVENT_NAMES, GTM_PROPS, EVENT, ECOMMERCE, PRODUCTS, ON_CLICK } from '../constants';
const buildNestedEvent = (ecommerce, propsObject, props, parentComponent) => {
  const {
    productDetailImpression,
    productClick
  } = GTM_EVENT_NAMES;
  const {
    eventAction,
    eventTrigger
  } = propsObject;
  const {
    name
  } = parentComponent;
  const gtmActionLabel = GTM_EVENT_NAMES[eventAction];
  const isClickEvent = eventTrigger === ON_CLICK || gtmActionLabel === productClick;
  const actionField = {
    list: name
  };
  const hasMultipleItems = Array.isArray(props);
  if (!ecommerce) {
    const basicEventObject = {};
    GTM_PROPS.forEach(({
      key,
      label
    }) => {
      const gtmValue = propsObject[key];
      const gtmKey = label || key;
      if (gtmValue) basicEventObject[gtmKey] = gtmValue;
    });
    const parsedProps = hasMultipleItems ? {
      items: props
    } : props;
    return _objectSpread(_objectSpread({}, basicEventObject), parsedProps);
  }
  if (!gtmActionLabel) return {
    [EVENT]: eventAction,
    [ECOMMERCE]: props
  };
  if (gtmActionLabel === productDetailImpression || gtmActionLabel === productClick) {
    const parsedProducts = hasMultipleItems ? props : [props];
    const eventObject = isClickEvent ? {
      [PRODUCTS]: parsedProducts,
      actionField
    } : {
      [PRODUCTS]: parsedProducts
    };
    return {
      [EVENT]: eventAction,
      [ECOMMERCE]: {
        [gtmActionLabel]: eventObject
      }
    };
  }
  const ecommerceObject = isClickEvent ? {
    [gtmActionLabel]: props,
    actionField
  } : {
    [gtmActionLabel]: props
  };
  return {
    [EVENT]: eventAction,
    [ECOMMERCE]: ecommerceObject
  };
};
export default buildNestedEvent;
//# sourceMappingURL=build-nested-event.js.map